import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isManagerView: false,
  selectedUserId: '',
  selectedUserName: '',
  managerUserList: [],
};

const managerDataSlice = createSlice({
  name: 'managerView',
  initialState,
  reducers: {
    saveIsManagerView(state, action) {
      state.isManagerView = action.payload;
    },
    saveSelectedUserId(state, action) {
      state.selectedUserId = action.payload;
    },
    saveSelectedUserName(state, action) {
      state.selectedUserName = action.payload;
    },
    saveManagerUserList(state, action) {
      state.managerUserList = action.payload;
    },
  },
});

export const {
  saveIsManagerView,
  saveSelectedUserId,
  saveSelectedUserName,
  saveManagerUserList,
} = managerDataSlice.actions;
export default managerDataSlice.reducer;
